// Generado por scripts/phone/generate-phone-countries.mjs desde libphonenumber-js 1.13.14.
// No editar a mano. [ISO, indicativo sin «+», país principal del indicativo]
export const PHONE_COUNTRY_ROWS: ReadonlyArray<readonly [string, string, boolean?]> = [
  ['AC', '247', true],
  ['AD', '376', true],
  ['AE', '971', true],
  ['AF', '93', true],
  ['AG', '1'],
  ['AI', '1'],
  ['AL', '355', true],
  ['AM', '374', true],
  ['AO', '244', true],
  ['AR', '54', true],
  ['AS', '1'],
  ['AT', '43', true],
  ['AU', '61', true],
  ['AW', '297', true],
  ['AX', '358'],
  ['AZ', '994', true],
  ['BA', '387', true],
  ['BB', '1'],
  ['BD', '880', true],
  ['BE', '32', true],
  ['BF', '226', true],
  ['BG', '359', true],
  ['BH', '973', true],
  ['BI', '257', true],
  ['BJ', '229', true],
  ['BL', '590'],
  ['BM', '1'],
  ['BN', '673', true],
  ['BO', '591', true],
  ['BQ', '599'],
  ['BR', '55', true],
  ['BS', '1'],
  ['BT', '975', true],
  ['BW', '267', true],
  ['BY', '375', true],
  ['BZ', '501', true],
  ['CA', '1'],
  ['CC', '61'],
  ['CD', '243', true],
  ['CF', '236', true],
  ['CG', '242', true],
  ['CH', '41', true],
  ['CI', '225', true],
  ['CK', '682', true],
  ['CL', '56', true],
  ['CM', '237', true],
  ['CN', '86', true],
  ['CO', '57', true],
  ['CR', '506', true],
  ['CU', '53', true],
  ['CV', '238', true],
  ['CW', '599', true],
  ['CX', '61'],
  ['CY', '357', true],
  ['CZ', '420', true],
  ['DE', '49', true],
  ['DJ', '253', true],
  ['DK', '45', true],
  ['DM', '1'],
  ['DO', '1'],
  ['DZ', '213', true],
  ['EC', '593', true],
  ['EE', '372', true],
  ['EG', '20', true],
  ['EH', '212'],
  ['ER', '291', true],
  ['ES', '34', true],
  ['ET', '251', true],
  ['FI', '358', true],
  ['FJ', '679', true],
  ['FK', '500', true],
  ['FM', '691', true],
  ['FO', '298', true],
  ['FR', '33', true],
  ['GA', '241', true],
  ['GB', '44', true],
  ['GD', '1'],
  ['GE', '995', true],
  ['GF', '594', true],
  ['GG', '44'],
  ['GH', '233', true],
  ['GI', '350', true],
  ['GL', '299', true],
  ['GM', '220', true],
  ['GN', '224', true],
  ['GP', '590', true],
  ['GQ', '240', true],
  ['GR', '30', true],
  ['GT', '502', true],
  ['GU', '1'],
  ['GW', '245', true],
  ['GY', '592', true],
  ['HK', '852', true],
  ['HN', '504', true],
  ['HR', '385', true],
  ['HT', '509', true],
  ['HU', '36', true],
  ['ID', '62', true],
  ['IE', '353', true],
  ['IL', '972', true],
  ['IM', '44'],
  ['IN', '91', true],
  ['IO', '246', true],
  ['IQ', '964', true],
  ['IR', '98', true],
  ['IS', '354', true],
  ['IT', '39', true],
  ['JE', '44'],
  ['JM', '1'],
  ['JO', '962', true],
  ['JP', '81', true],
  ['KE', '254', true],
  ['KG', '996', true],
  ['KH', '855', true],
  ['KI', '686', true],
  ['KM', '269', true],
  ['KN', '1'],
  ['KP', '850', true],
  ['KR', '82', true],
  ['KW', '965', true],
  ['KY', '1'],
  ['KZ', '7'],
  ['LA', '856', true],
  ['LB', '961', true],
  ['LC', '1'],
  ['LI', '423', true],
  ['LK', '94', true],
  ['LR', '231', true],
  ['LS', '266', true],
  ['LT', '370', true],
  ['LU', '352', true],
  ['LV', '371', true],
  ['LY', '218', true],
  ['MA', '212', true],
  ['MC', '377', true],
  ['MD', '373', true],
  ['ME', '382', true],
  ['MF', '590'],
  ['MG', '261', true],
  ['MH', '692', true],
  ['MK', '389', true],
  ['ML', '223', true],
  ['MM', '95', true],
  ['MN', '976', true],
  ['MO', '853', true],
  ['MP', '1'],
  ['MQ', '596', true],
  ['MR', '222', true],
  ['MS', '1'],
  ['MT', '356', true],
  ['MU', '230', true],
  ['MV', '960', true],
  ['MW', '265', true],
  ['MX', '52', true],
  ['MY', '60', true],
  ['MZ', '258', true],
  ['NA', '264', true],
  ['NC', '687', true],
  ['NE', '227', true],
  ['NF', '672', true],
  ['NG', '234', true],
  ['NI', '505', true],
  ['NL', '31', true],
  ['NO', '47', true],
  ['NP', '977', true],
  ['NR', '674', true],
  ['NU', '683', true],
  ['NZ', '64', true],
  ['OM', '968', true],
  ['PA', '507', true],
  ['PE', '51', true],
  ['PF', '689', true],
  ['PG', '675', true],
  ['PH', '63', true],
  ['PK', '92', true],
  ['PL', '48', true],
  ['PM', '508', true],
  ['PR', '1'],
  ['PS', '970', true],
  ['PT', '351', true],
  ['PW', '680', true],
  ['PY', '595', true],
  ['QA', '974', true],
  ['RE', '262', true],
  ['RO', '40', true],
  ['RS', '381', true],
  ['RU', '7', true],
  ['RW', '250', true],
  ['SA', '966', true],
  ['SB', '677', true],
  ['SC', '248', true],
  ['SD', '249', true],
  ['SE', '46', true],
  ['SG', '65', true],
  ['SH', '290', true],
  ['SI', '386', true],
  ['SJ', '47'],
  ['SK', '421', true],
  ['SL', '232', true],
  ['SM', '378', true],
  ['SN', '221', true],
  ['SO', '252', true],
  ['SR', '597', true],
  ['SS', '211', true],
  ['ST', '239', true],
  ['SV', '503', true],
  ['SX', '1'],
  ['SY', '963', true],
  ['SZ', '268', true],
  ['TA', '290'],
  ['TC', '1'],
  ['TD', '235', true],
  ['TG', '228', true],
  ['TH', '66', true],
  ['TJ', '992', true],
  ['TK', '690', true],
  ['TL', '670', true],
  ['TM', '993', true],
  ['TN', '216', true],
  ['TO', '676', true],
  ['TR', '90', true],
  ['TT', '1'],
  ['TV', '688', true],
  ['TW', '886', true],
  ['TZ', '255', true],
  ['UA', '380', true],
  ['UG', '256', true],
  ['US', '1', true],
  ['UY', '598', true],
  ['UZ', '998', true],
  ['VA', '39'],
  ['VC', '1'],
  ['VE', '58', true],
  ['VG', '1'],
  ['VI', '1'],
  ['VN', '84', true],
  ['VU', '678', true],
  ['WF', '681', true],
  ['WS', '685', true],
  ['XK', '383', true],
  ['YE', '967', true],
  ['YT', '262'],
  ['ZA', '27', true],
  ['ZM', '260', true],
  ['ZW', '263', true],
];
export const PHONE_METADATA_VERSION = '1.13.14';
